module.exports = __webpack_public_path__ + "static/media/mute_club_2.41b90b0f.png";